import {
    useCallback,
    useEffect,
    useState,
} from 'react';
import {
    FieldProps,
    useFormikContext
} from 'formik';
import {fetchRecords} from "../services/PricesService.ts";
import {Price} from "../types.ts";
import {FormikGenericCombobox} from "@flexinet/ui-components";
import {TextInputProps} from "@mantine/core";


const getProductIdUsingParentFieldName = (fieldName: string, values: Record<string, unknown>) => {

    console.debug('field.name', fieldName);
    console.debug('form values', values);

    // convert items.0.priceId to an array - [items, 0, priceId]
    const fieldNameParts = fieldName.split('.');
    console.debug('fieldNameParts in prices autocomplete', fieldNameParts);

    if (fieldNameParts.length < 3) {
        console.debug('Invalid field name format');
        return '';
    }

    const rowIndex = parseInt(fieldNameParts[1]);
    console.debug('rowIndex', rowIndex);

    const parentFieldName = fieldNameParts[0]; // 'items'
    console.debug('parentFieldName', parentFieldName);

    const parentValue = values[parentFieldName] as Record<string, unknown>[] | undefined;
    if (!parentValue || !parentValue[rowIndex]) {
        console.debug('No data found for row index', rowIndex);
        return '';
    }

    const productId = (parentValue[rowIndex] as Record<string, unknown>)['productId'] as string;
    console.debug('extracted productId', productId);

    return productId || '';

}


export const PricesAutocomplete = (props: FieldProps & TextInputProps) => {

    const {
        values,
    } = useFormikContext<Record<string, unknown>>();

    const [records, setRecords] = useState<(Price & { name: string })[]>([])
    const [loading, setLoading] = useState<boolean>(false)

    console.debug('values', values)

    const fetchItems = useCallback(() => {
        setLoading(true);
        const productId = getProductIdUsingParentFieldName(props.field.name, values)
        console.debug('productId', productId)

        if (!productId) {
            setLoading(false);
            setRecords([]);
            return;
        }

        fetchRecords(productId, {})
            .then(result => {
                if (result) {
                    const enhancedItems = result.items.map((item: Price) => {
                        return {
                            name: `${item.amount} ${item.billingPeriod}`,
                            ...item
                        }
                    });
                    setRecords(enhancedItems);
                }
            })
            .catch(error => {
                console.error('Error fetching prices:', error);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [props.field.name, values])


    useEffect(() => {
        const productId = getProductIdUsingParentFieldName(props.field.name, values);
        console.debug('productId in useEffect', productId);
        
        if (!productId) {
            setRecords([]);
            return;
        }

        fetchItems();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fetchItems, values]);


    console.debug('records', records)

    return (
        <FormikGenericCombobox
            records={records || []}
            valueFieldName={'id'}
            renderOption={(record: Price) => record ? `${record.amount} ${record.billingPeriod}` : null}
            getSelectedOption={(record: Price) => `${record.amount} ${record.billingPeriod}`}
            isLoading={loading}
            {...props}
        />
    );


};

